import React, { Component } from "react";
import Task from "./Task";
import { Link } from "react-router-dom";
import { getFilteredTasks } from "../Selectors/tasks";

class Tasks extends Component {
  state = {
    loading: true,
  };

  constructor() {
    super();
    this.onChange = this.onChange.bind(this);
    this.onSelect = this.onSelect.bind(this);
    // this.setState((state) => {
    //   return {
    //     ...state,
    //     tasks: getFilteredTasks(this.props.tasks),
    //   };
    // });
  }

  componentDidMount() {
    this.props.setStatusFilter("open");
    this.props.startLoadingTasks().then(() => {
      this.setState({ loading: false });
    });
    // this.setState((state) => {
    //   return {
    //     ...state,
    //     tasks: getFilteredTasks(this.props.tasks),
    //   };
    // });
    // this.props.startLoadingTasks(this.props.filters, this.props.id);
  }

  onChange(e) {
    this.props.setTaskFilter(e.target.value);
  }

  onSelect(e) {
    this.props.setStatusFilter(e.target.value);
  }

  render() {
    if (this.state.loading === true) {
      return <div className="loader">loading...</div>;
    } else {
      // console.log(filteredTasks.value, "filtered tasks");
      // console.log(tasks, "tasks");
      if (!this.props.tasks.value) {
        return (
          <Link className="btn btn-primary" to={`/AddTask/${this.props.id}`}>
            Add Task
          </Link>
        );
      } else {
        let tasks = this.props.tasks.value;
        let filteredTasks = this.props.tasks.value;
        // console.log(this.props.tasks, "render");
        filteredTasks = getFilteredTasks(
          this.props.tasks,
          this.props.filters,
          this.props.id
        );
        tasks = filteredTasks.value;
        return (
          <div className="container">
            <Link
              className="btn btn-primary mb-2"
              to={`/AddTask/${this.props.id}`}
            >
              Add Task
            </Link>
            <section>
              <input
                className="border border-secondary"
                type="text"
                onChange={this.onChange}
                name="filterTask"
                placeholder="Search Task"
              ></input>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input ms-5"
                  type="radio"
                  name="inlineRadioOptions"
                  id="inlineRadio1"
                  value="open"
                  defaultChecked
                  onClick={this.onSelect}
                />
                <label className="form-check-label" htmlFor="inlineRadio1">
                  Open Tasks
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="inlineRadioOptions"
                  id="inlineRadio2"
                  value="closed"
                  onClick={this.onSelect}
                />
                <label className="form-check-label" htmlFor="inlineRadio2">
                  Closed Tasks
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="inlineRadioOptions"
                  id="inlineRadio3"
                  value="all"
                  onClick={this.onSelect}
                />
                <label className="form-check-label" htmlFor="inlineRadio3">
                  All Tasks
                </label>
              </div>
              <table className="table table-hover table-fixed text-wrap">
                <tbody>
                  {tasks.map((task, index) => {
                    // console.log(task);
                    return (
                      <Task
                        key={index}
                        task={task}
                        taskid={this.props.tasks.key[index]}
                        userid={this.props.id}
                        startRemovingTask={this.props.startRemovingTask}
                        startClosingTask={this.props.startClosingTask}
                        startLoadingTasks={this.props.startLoadingTasks}
                        filters={this.props.filters}
                      />
                    );
                  })}
                </tbody>
              </table>
            </section>

            {/*// <Task />*/}
          </div>
        );
      }
    }
  }
}

export default Tasks;
